import React from 'react';

import { InventoryCard, ItemAchievement } from '.';
import { BankResponse } from '../../../../../../types/responses/bank-response';
import { GameDocumentContext } from '../../../../../../contexts/game-document';
import { generateTitleById } from '../../../../../../utils/game-document/display-languages';
import { DisplayLanguageContext } from '../../../../../../contexts/display-languages';

export const TeamInventory: React.FC<{
  bank: BankResponse | undefined;
  teamInventory: ItemAchievement[];
  setItemCard: React.Dispatch<
    React.SetStateAction<ItemAchievement | undefined>
  >;
}> = ({ bank, teamInventory, setItemCard }) => {
  const [gameDocument] = React.useContext(GameDocumentContext);
  const [displayLanguageContext] = React.useContext(DisplayLanguageContext);

  const preGameSetting = gameDocument.gameDocument?.settings.preGame;

  return (
    <div
      className={'h-100 d-flex flex-column flex-grow-1 gap-3'}
      style={{
        minHeight: '40%',
        padding: '12px',
        borderRadius: '8px',
        backgroundColor: '#1C445F4D'
      }}>
      <h2 className={'m-0 fw-bold'}>
        {generateTitleById(
          'a1b2c3d4-e5f6-a7b8-c9d0-e1f2a3b4c5d6',
          gameDocument,
          displayLanguageContext.displayLanguageSelected.resources!,
          'game'
        ) || 'Team Inventory'}
      </h2>

      <div
        className={'gap-3 h-100 d-flex flex-column flex-grow-1 overflow-auto'}>
        {(() => {
          const items = teamInventory
            .filter((item) => !item.hideInGame)
            .filter((item) => !item.bankItemGroupId);

          if (items.length === 0) return;
          return (
            <div className={'gap-2 d-flex flex-wrap'}>
              {items.map((item) => (
                <InventoryCard
                  key={item.id}
                  action={'return'}
                  item={item}
                  items={[]}
                  isTeamGame={preGameSetting?.isPreGameTeamRequired ?? false}
                  setItemCard={setItemCard}
                />
              ))}
            </div>
          );
        })()}

        {bank &&
          gameDocument.gameDocument?.assets.bankItemGroups?.map((group) => {
            const items = teamInventory.filter(
              (item) =>
                item.useBank &&
                !item.hideInGame &&
                item.bankItemGroupId === group.id
            );

            if (!items.length) return;
            return (
              <div className={'d-flex flex-column'} key={group.id}>
                <span
                  style={{
                    fontSize: '18px'
                  }}>
                  <b>{group.name}</b>
                </span>

                <div className={'gap-2 d-flex flex-wrap'}>
                  {items.map((item) => (
                    <InventoryCard
                      key={item.id}
                      item={item}
                      items={[]}
                      action={'return'}
                      isTeamGame={
                        preGameSetting?.isPreGameTeamRequired ?? false
                      }
                      setItemCard={setItemCard}
                    />
                  ))}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
